<template>
  <div>
    <v-dialog v-if="dialog" v-model="dialog" max-width="400">
      <SigninControl :on-cancel="cancel" />
    </v-dialog>
    <SigninControl v-else />
  </div>
</template>

<script>
import SigninControl from '@/components/auth/SigninControl.vue';

export default {
  components: {
    SigninControl
  },
  props: {
    showSignin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { dialog: false };
  },
  mounted () {
    this.dialog = this.showSignin;
  },
  methods: {
    cancel () {
      this.dialog = false;
    }
  }
};
</script>
